// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".atom-customer{align-items:center;display:flex;flex:0 auto;flex-direction:column;justify-content:center;max-height:10rem;padding:1rem .8rem;width:8%}@media only screen and (max-width:767px){.atom-customer{padding:.5rem;width:20%}}.atom-customer img{display:block;max-width:90%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
